import loadable from '@loadable/component';

const PopularDestinationsModule = loadable(
    () =>
        import(
            /* webpackChunkName: "popular-destinations" */
            './'
        ),
    {ssr: false}
);

PopularDestinationsModule.displayName = 'PopularDestinationsModule';

export default PopularDestinationsModule;
